const calculatePercent = (part: number, whole: number): number => {
  if (part === 0) return 0;
  return Math.round((part / whole) * 100);
};

export default calculatePercent;
